import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/heatmapSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const SecondaryCategory = () => {
  const dispatch = useDispatch();

  const { selectedSecondaryCategories, secondaryCategories } = useSelector(
    (state) => state.retentionHeatmap
  );

  return (
    <MultiSelectDropdown
      options={secondaryCategories}
      selectedFilters={selectedSecondaryCategories}
      placeholder="Secondary Categories"
      numberDisplayed={0}
      includeSelectAll
      enableOnly
      height={324}
      onSelectChange={(data) => dispatch(actionCreators.updateSecondaryCategory(data))}
    />
  );
};

export default SecondaryCategory;
